import {
  inferScopeKind,
  type RoleInfoLite,
  type ScopeKind,
} from "./inferScopeKind";

type GrantLike = {
  scopeId: string;
  builtinRoleId: string | null;
  customRoleId: string | null;
};

export type HiddenScopeCounts = {
  space: number;
  connected_app: number;
};

export function countHiddenScopes(
  grants: readonly GrantLike[],
  visibleIds: ReadonlySet<string>,
  rolesMap: ReadonlyMap<string, RoleInfoLite>
): HiddenScopeCounts {
  const hiddenSpaces = new Set<string>();
  const hiddenApps = new Set<string>();
  for (const grant of grants) {
    const kind = inferScopeKind(grant, rolesMap);
    if (!kind) continue;
    if (visibleIds.has(grant.scopeId)) continue;
    if (kind === "space") hiddenSpaces.add(grant.scopeId);
    else hiddenApps.add(grant.scopeId);
  }
  return { space: hiddenSpaces.size, connected_app: hiddenApps.size };
}

export function countHiddenScopesOfKind(
  grants: readonly GrantLike[],
  kind: ScopeKind,
  visibleIds: ReadonlySet<string>,
  rolesMap: ReadonlyMap<string, RoleInfoLite>
): number {
  const hidden = new Set<string>();
  for (const grant of grants) {
    if (inferScopeKind(grant, rolesMap) !== kind) continue;
    if (!visibleIds.has(grant.scopeId)) hidden.add(grant.scopeId);
  }
  return hidden.size;
}
